module.exports = __webpack_public_path__ + "img/WT_AR.ce733b43.png";